import React from 'react'
import './Fashion.css'
import Product from './Product';

function Fashion() {
    return (
        <div>
        <div className="fashion">
          <img className="fasimg"  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/Flip/Winterwear21/AFPage/header_strip_mob-1.jpg"/>
          <img className="fasoneimg"  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/Flip/Winterwear21/AFPage/Bankstripe/PC.jpg"/>
          <img className="fastwoimg"  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/Event/SS21Flip/PC_Changes/FST/free-delivery.jpg"/>
          <img className="fastwoimg"  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/N2SL/V2/WomenClothing/womens-clothing__01.jpg"/>
          </div>
          <div className="home_row">

<Product title='God Bless
Women' price={399}  image='https://m.media-amazon.com/images/I/712HeyuPFNL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Butterfly Tops for Women Stylish"price={459}  image='https://m.media-amazon.com/images/I/61tZjIlf3qL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Women's Regular Fit Fashion Vest "price={349}  image='https://m.media-amazon.com/images/I/71H1QZVBq6L._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Women's Regular Fit Top"price={466}  image='https://m.media-amazon.com/images/I/81fTUodaQjL._AC_UL480_FMwebp_QL65_.jpg' rating={5} />
</div>
<div className="fashion">
<img className="fastwoimg "  src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Fashion/N2SL/V2/Men/mens-clothing__01.jpg"/>
</div>
<div className="home_row">

<Product title='White Regular Fit T-Shirt' price={649}  image='https://m.media-amazon.com/images/I/81sg7JxzMDL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Men's Regular fit Polo"price={728}  image='https://m.media-amazon.com/images/I/91jpRsTPpUL._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
<Product title="Men's Slim Fit Casual Shirt "price={349}  image='https://m.media-amazon.com/images/I/81kJzDOwjNL._AC_UL480_FMwebp_QL65_.jpg' rating={5} />
<Product title="Amazon Brand - Symbol"price={499}  image='https://m.media-amazon.com/images/I/71Ga6S4898L._AC_UL480_FMwebp_QL65_.jpg' rating={4} />
</div>
</div>
        
    )
}

export default Fashion
